export interface IAuth extends IUser {
  expires_in: string;
  token: string;
  type: string;
}

export interface IUser {
  company_id: number;
  company_name?: string;
  is_company_admin: boolean;
  is_super_admin: boolean;
  enabled: boolean;
  id: number;
  last_name: string;
  name: string;
  password: string;
  photo: string;
  phone: string;
  phone_ext: string;
  username: string;
  is_operator: boolean;
  shipper_type?: string;
  last_activity_at?: string;
  role?: IRol;
  office_location_id?:number,
  place?: {
    address: string;
    address2: string;
    city: string;
    state: string;
    zipcode: string;
  };
  office_location?:{
    id: number,
    name: string
  };
  driving_license_file_path?: string;
  Company?:{
    id: number,
    name: string
  };
}

export interface IUsersResponse {
  total: number;
  count: number;
  page: number;
  records: IUser[];
}

export interface IResponseSalesList {
  total: number;
  count: number;
  page: number;
  records: ISales[];
}

export interface ISales extends IUser {
  succes_rate: number;
}

export interface IRol {
  id: number;
  name: string;
}

export interface IDriver extends IUser {
  driver_status: string;
  orders_moved: number;
  url_file: string;
  insurance_expire: string;
}

export interface ActionPermission {
  not_signed: boolean;
  dispatched: boolean;
  in_transit: boolean;
  delivered: boolean;
  open_invoice: boolean;
  damage: boolean;
  paid_bills: boolean;
  only_heavy_haul: boolean;
  only_automotive: boolean
}

export interface UserPermissionResponse {
  id: number;
  user_id: number;
  update_order: ActionPermission;
  dispatch_privileges: DispatchPrivileges;
  payment_privileges: PaymentPrivileges;
  reports: boolean;
}

export const DEFUALT_USER_ACTIONS: UserPermissionResponse = {
  id: null,
  user_id: null,
  update_order: {
    not_signed: false,
    dispatched: false,
    in_transit: false,
    delivered: false,
    open_invoice: false,
    damage: false,
    paid_bills: false,
    only_heavy_haul:false,
    only_automotive:false,
  },
  dispatch_privileges: {
    perform_dispatch: false,
    edit_dispatch: false,
    use_carrier_match: false
  },
  payment_privileges: {
    process_payment: false,
    edit_carrier_terms: false
  },
  reports: false
};

export interface DispatchPrivileges {
  perform_dispatch: boolean;
  edit_dispatch: boolean;
  use_carrier_match: boolean;
}

export interface PaymentPrivileges {
  process_payment: boolean;
  edit_carrier_terms: boolean;
}

export interface IAppComponent {
  name: string;
  path: string;
  params: string;
  main: boolean;
  active: boolean;
}

export const APP_COMPONENTS: IAppComponent[] = [
  {
    name: 'identity',
    path: null,
    params: null,
    main: true,
    active: false
  },
  {
    name: 'b2b',
    path: '/B2B/processor/',
    params: null,
    main: false,
    active: false
  },
  {
    name: 'esign',
    path: '/esign/processor/',
    params: null,
    main: false,
    active: false
  },
  {
    name: 'dispatch-sheet',
    path: '/dispatch-sheet/processor/',
    params: null,
    main: false,
    active: false
  },
  {
    name: 'mercury-credit-card',
    path: '/mercury/credit-card/',
    params: null,
    main: false,
    active: false
  },
  {
    name: 'get-quote',
    path: '/get-quote',
    params: null,
    main: false,
    active: false
  }
];

export const ROLES: string[] = [
  'fronter',
  'sales_rep',
  'sales_manager',
  'dispatcher',
  'track_trace',
  'account_payable',
  'account_receivable',
  'carrier_relations',
  'super_admin',
  'data_entry',
  'quality_assurance',
  'carrier_sales'
];

export interface IDispatchers extends IUser {
  succes_rate: number;
}
export interface IResponseDispatcherList {
  total: number;
  count: number;
  page: number;
  records: ISales[];
}